import './MixedPlotlyChartComponent.scss';
import '../../Utils/Variables.scss';

import {
  CCGTdetailsHistory,
  CCGTdetailsRealTime,
  CCGTMSDreport,
  GlobalApiFactory,
  HomePlant, WindBioEnergyDetailsHistory, WindBioEnergyDetailsRealTime
} from '../../Services/typescript-fetch-client';
import {Link, useNavigate, useSearchParams} from 'react-router-dom';
import useWindowDimensions from "../ui-components/useWindowDimensions";
import CCGTPlotlyComponent from "../PlotlyComponent/CCGTPlotlyComponent";
import RenewPlotlyComponent from "../PlotlyComponent/RenewPlotlyComponent";
import decimalRound from "../../Utils/decimalRound";
import { Tag } from 'primereact/tag';
import {Card} from "primereact/card";
import formatNumber from "../../Utils/formatNumber";
import TypeEnum = HomePlant.TypeEnum;
import ConditionalWrapper from "../../Components/ui-components/ConditionalWrapper";
import {ZoomElement} from "../../Models/ZoomElement";
import React, { useContext, useEffect, useState } from "react";
import {Button} from "primereact/button";
import { ReactComponent as WindSvg} from  '../ui-components/icons/Eolico.svg'
import { ReactComponent as BioSvg} from  '../ui-components/icons/Bioenergie.svg'
import { ReactComponent as GasSvg} from  '../ui-components/icons/Gas.svg'
import {LegendSerie} from "../PlotsSharedLegend/PlotsSharedLegend";
import ProfiliCaricoContext from '../../Context/ProfiliCaricoContext';
import { InteractionRequiredAuthError } from '@azure/msal-browser';

enum Mode {
  RealTime,
  History
}

type Props = {
  isSingleGraph: boolean,
  isPlant: boolean,
  url: string | null,
  allGraphsAction?: () => void,
  showDetailKpis: boolean,
  plantName: string,
  fullScale: number,
  type: TypeEnum,
  ccgtDetailsRealTime?: CCGTdetailsRealTime,
  ccgtDetailsHistory?: CCGTdetailsHistory,
  maxMSDloaded?: CCGTMSDreport.LabelEnum,
  visibleSeries: Map<string, LegendSerie>,
  windBioEnergyDetailsHistory?: WindBioEnergyDetailsHistory,
  windBioEnergyDetailsRealTime?: WindBioEnergyDetailsRealTime,
  zoom: ZoomElement,
  setZoom: React.Dispatch<React.SetStateAction<ZoomElement | null>>,
  zoomBack: () => void,
  backToInitialZoom: () => void,
  children?: React.ReactNode,
};

const MixedPlotlyChartComponent = (props: Props) => {
  const { height, width } = useWindowDimensions();
  const nav = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const context = useContext(ProfiliCaricoContext);
  const [homePlant, setHomePlant] = useState<HomePlant[]>([]);


  const addKpiRow = (label: string, valueUom: any) => {
    return <div className="col-12 sd:col-4 md:col-4 lg:col-4">
      <Card className="detailDataContainer">
        <div className="flex align-items-center justify-content-center plantDetailsLabel">{label}</div>
        <div className="flex align-items-center justify-content-center plantDetailsValue">{valueUom}</div>
      </Card></div>
  };
  
  const screenFactorH = (height: number, width: number) => {
    return width >= height;
  }

  useEffect(() => {
    if (context.accessToken) {
        GlobalApiFactory({accessToken: context.accessToken!, apiKey: "123"}).globalAllPlantsGet().then((homePlantsAPI: HomePlant[]) => {
            let plant = homePlantsAPI.filter(p => p.plantName === props.plantName);
            console.log(plant, "PLANNNTTNNTTNTN");
            
            setHomePlant(plant);
        }).catch((e) => {
            if (e instanceof InteractionRequiredAuthError)
                context.doAcquireTokenRedirect();
            else
                context.showMsg("Errore", "Si è verificato un errore inaspettato nella lettura degli impianti", "error")
        });
    }
}, [context, context.accessToken, nav, props.plantName]);

  return <div>
    {(props.type === HomePlant.TypeEnum.Ccgt) && (getMode(props) === Mode.RealTime) && (
        <>
          <div className="graphTitle">
            <div className="flex justify-content-start align-items-center flex-wrap">
              { props.isSingleGraph && props.isPlant && <Button className="p-button-raised backLink p-button-sm" onClick={(typeof props.allGraphsAction == "undefined" ? () => { nav("/" + props.type + "?" + searchParams.toString()) } : props.allGraphsAction)} icon="pi pi-chevron-left" />}
              <Link className="mr-2" to={props.url! + "?" + searchParams.toString()}><GasSvg title="CCGT" className="mr-2"/>{props.plantName}</Link>
              {(props.maxMSDloaded) ? <Tag severity="success" rounded>{props.maxMSDloaded}</Tag> : <Tag severity="warn" rounded>Nessun MSD</Tag>}
            </div>
          </div>
          <CCGTPlotlyComponent isSinglePlantView={props.isSingleGraph} ccgtSeries={props.ccgtDetailsRealTime!.series!}
                               isLandscape={screenFactorH(height, width)}
                               viewName={props.plantName} maxY={props.fullScale} visibleSeries={props.visibleSeries}
          zoom={props.zoom} zoomBack={props.zoomBack} setZoom={props.setZoom} backToInitialZoom={props.backToInitialZoom} height={height}/>
          {props.children}
          {props.showDetailKpis &&
              <div className="CCGTdetailPanelRealTime">
                <div className="flex justify-content-center align-items-center flex-wrap kpi-panel">
                  {addKpiRow("Piano fattibile", formatNumber(decimalRound(props.ccgtDetailsRealTime!.feasiblePlan!, 1)) + " MW")}
                  {addKpiRow("Potenza d'impianto", formatNumber(decimalRound(props.ccgtDetailsRealTime!.powerPlant!, 1)) + " MW")}
                  {addKpiRow("Consumo gas dalle ore 6", formatNumber(decimalRound(props.ccgtDetailsRealTime!.gasConsumptionSixHours!, 0)) + " Sm3")}
                  {addKpiRow("Potenza TG1", formatNumber(decimalRound(props.ccgtDetailsRealTime!.powerTG1!, 1)) + " MW")}
                  {addKpiRow("Potenza TG2", formatNumber(decimalRound(props.ccgtDetailsRealTime!.powerTG2!, 1)) + " MW")}
                  {addKpiRow("Potenza TV", formatNumber(decimalRound(props.ccgtDetailsRealTime!.powerTV!, 1)) + " MW")}
                </div>
              </div>
          }

          {/*(props.singleView) &&
        <div className="CCGTdetailPanelReatTime">
          <div className="flex justify-content-center align-items-start flex-wrap kpi-panel">
              {addKpiRow("Piano fattibile", formatNumber(decimalRound(props.ccgtDetailsRealTime.feasiblePlan, 1)) + " MW")}
              {addKpiRow("Potenza d'impianto", formatNumber(decimalRound(props.ccgtDetailsRealTime.powerPlant, 1)) + " MW")}
              {addKpiRow("C. gas dalle ore 6", formatNumber(decimalRound(props.ccgtDetailsRealTime.gasConsumptionSixHours, 0)) + " Sm3")}
              {addKpiRow("Potenza TG1", formatNumber(decimalRound(props.ccgtDetailsRealTime.powerTG1, 1)) + " MW")}
              {addKpiRow("Potenza TG2", formatNumber(decimalRound(props.ccgtDetailsRealTime.powerTG2, 1)) + " MW")}
              {addKpiRow("Potenza TV", formatNumber(decimalRound(props.ccgtDetailsRealTime.powerTV, 1)) + " MW")}           
          </div>
  </div>*/}
        </>)}

    {((props.type === HomePlant.TypeEnum.Wind || props.type === HomePlant.TypeEnum.Bioenergy) && getMode(props) === Mode.RealTime) &&
        (<>
          <div className="graphTitle">
            <div className="flex justify-content-start align-items-center flex-wrap">
              { props.isSingleGraph && props.isPlant && <Button className="p-button-raised backLink p-button-sm" onClick={(typeof props.allGraphsAction == "undefined" ? () => { nav("/" + props.type + "?" + searchParams.toString()) } : props.allGraphsAction)} icon="pi pi-chevron-left" />}
              <ConditionalWrapper condition={props.url != null && props.url !== ""} wrapper={(children) => <Link to={props.url! + "?" + searchParams.toString()} className="mr-2">{children}</Link>}>
                {( props.type === HomePlant.TypeEnum.Wind ) && <WindSvg title="Eolico" className="mr-2"/>}
                {( props.type === HomePlant.TypeEnum.Bioenergy ) && <BioSvg title="Bio Energia" className="mr-2"/>}
                {props.type === HomePlant.TypeEnum.Wind ? homePlant.length > 0 && `${props.plantName} (${homePlant[0].province?.name})` : homePlant.length > 0 && `${props.plantName}`}
              </ConditionalWrapper>
            </div>
          </div>
          <RenewPlotlyComponent isSinglePlantView={props.isSingleGraph} windBioEnergySeries={props.windBioEnergyDetailsRealTime!.series!}
                                isLandscape={screenFactorH(height, width)} viewName={props.plantName} maxY={props.fullScale} visibleSeries={props.visibleSeries}
        zoom={props.zoom} zoomBack={props.zoomBack} setZoom={props.setZoom} backToInitialZoom={props.backToInitialZoom} />
          {props.children}
          {props.showDetailKpis &&
              <div className="flex justify-content-center align-items-center flex-wrap kpi-panel">
                {addKpiRow(props.isPlant ? "Potenza d'impianto" : "Potenza prodotta", formatNumber(decimalRound(props.windBioEnergyDetailsRealTime!.powerProd!, 1)) + " MW")}
                {addKpiRow("Piano da forecast", formatNumber(decimalRound(props.windBioEnergyDetailsRealTime!.powerForecasted!, 1)) + " MW")}
              </div>}
        </>)}

    {(props.type === HomePlant.TypeEnum.Ccgt) && (getMode(props) === Mode.History) &&
        <>
          <div className="graphTitle">
            <div className="flex justify-content-start align-items-center flex-wrap">
              { props.isSingleGraph && props.isPlant && <Button className="p-button-raised backLink p-button-sm" onClick={(typeof props.allGraphsAction == "undefined" ? () => { nav("/" + props.type + "?" + searchParams.toString()) } : props.allGraphsAction)} icon="pi pi-chevron-left" />}
              <Link className="mr-2" to={props.url! + "?" + searchParams.toString()}><GasSvg title="CCGT" className="mr-2"/>{props.plantName}</Link>
            </div>
          </div>
          <CCGTPlotlyComponent isSinglePlantView={props.isSingleGraph} ccgtSeries={props.ccgtDetailsHistory!.series!}
                               isLandscape={screenFactorH(height, width)}
                               viewName={props.plantName} maxY={props.fullScale} visibleSeries={props.visibleSeries}
        zoom={props.zoom} zoomBack={props.zoomBack} setZoom={props.setZoom} backToInitialZoom={props.backToInitialZoom} height={height}/>
          {props.children}
          {props.showDetailKpis && 
              <div className="flex justify-content-center align-items-center flex-wrap kpi-panel">
                {addKpiRow("Load Factor", props.ccgtDetailsHistory!.loadFactor + "%")}
                {addKpiRow("EE Prod", formatNumber(decimalRound(props.ccgtDetailsHistory!.eeProd!, 0)) + " GWh")}
                {addKpiRow("Start TG1", props.ccgtDetailsHistory!.startTG1)}
                {addKpiRow("Start TG2", props.ccgtDetailsHistory!.startTG2)}
                {addKpiRow("Start TV", props.ccgtDetailsHistory!.startTV)}
              </div>}
        </>
    }
    
    {((props.type === HomePlant.TypeEnum.Wind || props.type === HomePlant.TypeEnum.Bioenergy) && getMode(props) === Mode.History) &&
        <>
          <div className="graphTitle">
            <div className="flex justify-content-start align-items-center flex-wrap">
              { props.isSingleGraph && props.isPlant && <Button className="p-button-raised backLink p-button-sm" onClick={(typeof props.allGraphsAction == "undefined" ? () => { nav("/" + props.type + "?" + searchParams.toString()) } : props.allGraphsAction)} icon="pi pi-chevron-left" />}
              <ConditionalWrapper condition={props.url != null && props.url !== ""} wrapper={(children) => <Link to={props.url! + "?" + searchParams.toString()} className="mr-2">{children}</Link>}>
                {( props.type === HomePlant.TypeEnum.Wind ) && <WindSvg title="Wind" className="mr-2"/>}
                {( props.type === HomePlant.TypeEnum.Bioenergy ) && <BioSvg title="Bioenergy" className="mr-2"/>}
                {homePlant.length > 0 && `${props.plantName} (${homePlant[0].province?.name})`}
                {homePlant.length === 0 && props.plantName}
              </ConditionalWrapper>
            </div>
          </div>
          <RenewPlotlyComponent isSinglePlantView={props.isSingleGraph} windBioEnergySeries={props.windBioEnergyDetailsHistory!.series!}
                                isLandscape={screenFactorH(height, width)} viewName={props.plantName} maxY={props.fullScale} visibleSeries={props.visibleSeries}
        zoom={props.zoom} zoomBack={props.zoomBack} setZoom={props.setZoom} backToInitialZoom={props.backToInitialZoom} />
          {props.children}
          {props.showDetailKpis &&
              <div className="flex justify-content-center align-items-center flex-wrap kpi-panel">
                {addKpiRow("EE Prodotta", formatNumber(decimalRound(props.windBioEnergyDetailsHistory!.eeprod!, 0)) + " MWh")}
                {addKpiRow("EE da forecast", formatNumber(decimalRound(props.windBioEnergyDetailsHistory!.eeForcasted!, 0)) + " MWh")}
              </div>}
        </>}
  </div>;
};

const getMode = (props: any) => {
  if (props.ccgtDetailsRealTime)
    return Mode.RealTime;
  if (props.ccgtDetailsHistory)
    return Mode.History;
  if (props.windBioEnergyDetailsRealTime)
    return Mode.RealTime;
  if (props.windBioEnergyDetailsHistory)
    return Mode.History;
  return props;
};


export default MixedPlotlyChartComponent;
